import Base_url from "./Base_url.js"

export let BASE_URL = Base_url['pro'].url